import { ButtonGroup, Pagination as ChakraPagination, IconButton } from '@chakra-ui/react';
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu';

interface IPaginationProps {
  totalPages: number;
  pageSize: number;
  page: number;
  onPageChange: (page: number) => void;
}

const Pagination = ({ totalPages, pageSize = 5, page = 1, onPageChange }: IPaginationProps) => {
  return (
    <ChakraPagination.Root count={totalPages * pageSize} pageSize={pageSize} page={page}>
      <ButtonGroup variant="ghost" size="sm" wrap="wrap">
        <ChakraPagination.PrevTrigger asChild onClick={() => onPageChange(page - 1)}>
          <IconButton>
            <LuChevronLeft />
          </IconButton>
        </ChakraPagination.PrevTrigger>

        <ChakraPagination.Items
          render={(item) => {
            return (
              <IconButton
                bg={{ base: 'transparent', _selected: 'purple.800' }}
                color={{ base: 'black', _selected: 'white' }}
                variant={{ base: 'outline', _selected: 'solid' }}
                onClick={() => onPageChange(item.value)}
              >
                {item.value}
              </IconButton>
            );
          }}
        />

        <ChakraPagination.NextTrigger asChild onClick={() => onPageChange(page + 1)}>
          <IconButton>
            <LuChevronRight />
          </IconButton>
        </ChakraPagination.NextTrigger>
      </ButtonGroup>
    </ChakraPagination.Root>
  );
};

export default Pagination;
